import { LicenseScope } from '@platform-frontend/marketplace';

export interface AcademicRegistrationData {
  firstName: string;
  lastName: string;
  email: string;
  organizationName: string;
  organizationWeb: string;
  licenseScope: LicenseScope;
}
